/* Links.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["size", "type", "children", "href", "onClick", "dataTestId", "animateIcon", "underlineText"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _33 = "._1e0c116y{display:inline-flex}";
const _32 = "._o5721q9c{white-space:nowrap}";
const _31 = "._t4pt1hna>span{overflow-wrap:break-word}";
const _30 = "._y3gn1e5h{text-align:left}";
const _29 = "._1e0c1o8l{display:inline-block}";
const _28 = "._12svdejf:hover svg{transform:translateX(var(--ds-space-050,4px))}";
const _27 = "._l8kux7w3 svg{transition:transform .25s ease-in-out}";
const _26 = "._ku3unqa1:hover .linkText{-webkit-text-decoration-style:solid;text-decoration-style:solid}";
const _25 = "._apju8stv:hover .linkText{-webkit-text-decoration-line:underline;text-decoration-line:underline}";
const _24 = "._1jmq18uv:hover .linkText{-webkit-text-decoration-color:initial;text-decoration-color:initial}";
const _23 = "._4cvr1h6o{align-items:center}";
const _22 = "._1e0c1txw{display:flex}";
const _21 = "._syaz14q2{color:var(--ds-link,#0c66e4)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { DiagonalUpwardArrowIcon } from '../Icons/DiagonalUpwardArrowIcon';
import { RightArrowIcon } from '../Icons/RightArrowIcon';
import { TEST_IDS } from '../TestIds';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _20 = "._k48pni7l{font-weight:600}";
const _19 = "._k48p1nn1{font-weight:400}";
const _18 = "._1wyb1j6v{font-size:1rem}";
const _17 = "._1wyboxwj{font-size:.875rem}";
const _16 = "._9h8h16c2:active{color:var(--ds-link-pressed,#05c)}";
const _15 = "._1iohnqa1:active{-webkit-text-decoration-style:solid;text-decoration-style:solid}";
const _14 = "._c2waglyw:active{-webkit-text-decoration-line:none;text-decoration-line:none}";
const _13 = "._1nrm18uv:active{-webkit-text-decoration-color:initial;text-decoration-color:initial}";
const _12 = "._30l314q2:hover{color:var(--ds-link,#0c66e4)}";
const _11 = "._jf4cnqa1:hover{-webkit-text-decoration-style:solid;text-decoration-style:solid}";
const _10 = "._1bnxglyw:hover{-webkit-text-decoration-line:none;text-decoration-line:none}";
const _9 = "._9oik18uv:hover{-webkit-text-decoration-color:initial;text-decoration-color:initial}";
const _8 = "._1ygbugt7:focus-visible{outline:2px solid var(--ds-border-focused,#388bff)}";
const _7 = "._1bas14y2:focus-visible{border-radius:5px}";
const _6 = "._vwz4gktf{line-height:20px}";
const _5 = "._syaz1fxt{color:var(--ds-text,#172b4d)}";
const _4 = "._ect418aq{font-family:var(--ds-font-family-brand-body,\"Charlie Text\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const _3 = "._ajmmnqa1{-webkit-text-decoration-style:solid;text-decoration-style:solid}";
const _2 = "._1hmsglyw{-webkit-text-decoration-line:none;text-decoration-line:none}";
const _ = "._4bfu18uv{-webkit-text-decoration-color:initial;text-decoration-color:initial}";
const getExternalLinkAttributes = text => {
  const linkText = typeof text === 'string' ? "".concat(text, " ") : '';
  return {
    target: '_blank',
    rel: 'external noopener noreferrer',
    'aria-label': "".concat(linkText, "open in new window")
  };
};
export const SubtleLink = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "a",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_4bfu18uv _1hmsglyw _ajmmnqa1 _ect418aq _syaz1fxt _vwz4gktf _1bas14y2 _1ygbugt7 _9oik18uv _1bnxglyw _jf4cnqa1 _30l314q2 _1nrm18uv _c2waglyw _1iohnqa1 _9h8h16c2", __cmplp.size === 'small' ? "_1wyboxwj" : "_1wyb1j6v", __cmplp.size === 'small' ? "_k48p1nn1" : "_k48pni7l", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  SubtleLink.displayName = 'SubtleLink';
}
export const Link = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "a",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_4, _21, _6, _7, _8, _16, _17, _18, _19, _20]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_ect418aq _syaz14q2 _vwz4gktf _1bas14y2 _1ygbugt7 _9h8h16c2", __cmplp.size === 'small' ? "_1wyboxwj" : "_1wyb1j6v", __cmplp.size === 'small' ? "_k48p1nn1" : "_k48pni7l", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Link.displayName = 'Link';
}
const LinkWithIconStyles = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = Link,
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_22, _23, _9, _10, _11, _24, _25, _26, _27, _28]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _4cvr1h6o _9oik18uv _1bnxglyw _jf4cnqa1", __cmplp.underlineText && "_1jmq18uv _apju8stv _ku3unqa1", __cmplp.animateIcon && "_l8kux7w3 _12svdejf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  LinkWithIconStyles.displayName = 'LinkWithIconStyles';
}
export const ExternalLink = props => {
  const externalAttributes = getExternalLinkAttributes(props['aria-label'] || props.children);
  const linkProps = _objectSpread(_objectSpread(_objectSpread({}, props), externalAttributes), {}, {
    size: props.size || 'medium'
  });
  return linkProps.type === 'subtle' ? /*#__PURE__*/_jsx(SubtleLink, _objectSpread(_objectSpread({}, linkProps), {}, {
    children: props.children
  })) : /*#__PURE__*/_jsx(Link, _objectSpread(_objectSpread({}, linkProps), {}, {
    children: props.children
  }));
};
const LinkWithIconWrapper = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "span",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_29, _30, _31]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1o8l _y3gn1e5h _t4pt1hna", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  LinkWithIconWrapper.displayName = 'LinkWithIconWrapper';
}
const LastWordWithIcon = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = "span",
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_32, _33, _23]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_o5721q9c _1e0c116y _4cvr1h6o", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  LastWordWithIcon.displayName = 'LastWordWithIcon';
}
export const ExternalSubtleLink = props => {
  const externalAttributes = getExternalLinkAttributes(props['aria-label'] || props.children);
  const linkProps = _objectSpread(_objectSpread({}, props), externalAttributes);
  return /*#__PURE__*/_jsx(SubtleLink, _objectSpread(_objectSpread({}, linkProps), {}, {
    children: props.children
  }));
};
export const LinkWithIcon = _ref6 => {
  let {
      size,
      type = 'internal',
      children,
      href,
      onClick,
      dataTestId,
      animateIcon = false,
      underlineText = true
    } = _ref6,
    props = _objectWithoutProperties(_ref6, _excluded6);
  let linkProps = _objectSpread({
    href,
    onClick
  }, props);
  let icon;
  if (type === 'external') {
    icon = /*#__PURE__*/_jsx(DiagonalUpwardArrowIcon, {});
    const externalAttributes = getExternalLinkAttributes(children);
    linkProps = _objectSpread(_objectSpread({}, externalAttributes), linkProps);
  } else if (type === 'internal') {
    icon = /*#__PURE__*/_jsx(RightArrowIcon, {});
  }
  if (typeof children === 'string') {
    const words = children.split(' ');
    const lastWord = words.pop();
    return /*#__PURE__*/_jsx(LinkWithIconStyles, _objectSpread(_objectSpread({
      size: size
    }, linkProps), {}, {
      underlineText: underlineText,
      animateIcon: animateIcon,
      "data-testid": dataTestId || TEST_IDS.APP_LINK_WITH_ICON,
      children: /*#__PURE__*/_jsxs(LinkWithIconWrapper, {
        children: [/*#__PURE__*/_jsx("span", {
          className: "linkText",
          children: words.join(' ')
        }), ' ', /*#__PURE__*/_jsxs(LastWordWithIcon, {
          children: [/*#__PURE__*/_jsx("span", {
            className: "linkText",
            children: lastWord
          }), icon]
        })]
      })
    }));
  }
  return /*#__PURE__*/_jsxs(LinkWithIconStyles, _objectSpread(_objectSpread({
    size: size
  }, linkProps), {}, {
    "data-testid": TEST_IDS.APP_LINK_WITH_ICON,
    animateIcon: animateIcon,
    underlineText: underlineText,
    children: [/*#__PURE__*/_jsx("span", {
      className: "linkText",
      children: children
    }), icon]
  }));
};